import React from 'react';
import { useSelector } from 'react-redux';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn } from '~/components/EditAndAddItem';

const emptyBody = {
  a: '',
  b: '',
};

const App = ({ titleWidth, disabled, checkSubChange, changeData, data }) => {
  const PSRent = useSelector(state => state.data.PSRent || []);
  const ary = JSON.parse(data.lessor || '[]');
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'lessor', data: JSON.stringify(dataAry) });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  return ary.map((o, i) => (
    <EAA_Row key={`Page_Contract_lessor_${i}`}>
      <EAA_Item>
        <EAA_ItemContainer>
          <EAA_TitleText width={titleWidth} bol text='出租方' />
          <EAA_Select disabled={disabled} displayBorder list={PSRent} marginRight={12} value={o.a} onChange={data => { ary[i].a = data; ary[i].b = ''; saveSub(ary); }} />
          {o.a === '其他' && <EAA_Input disabled={disabled} displayBorder hint='詳答填入' marginRight={12} value={o.b} onChange={data => { ary[i].b = data; saveSub(ary); }} />}
          {o.a !== '其他' && <div style={{ flex: 1, marginLeft: 12 }} />}
          <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
        </EAA_ItemContainer>
      </EAA_Item>
    </EAA_Row>
  ));
};

export default App;
